import {
  CandidateReferralBuilder,
  GetCandidateReferralsInput,
  GetCandidateReferralsOutput,
} from '../candidate-referrals.types';

export const getCandidateReferrals = (builder: CandidateReferralBuilder) =>
  builder.query<GetCandidateReferralsOutput, GetCandidateReferralsInput>({
    query: ({ candidateId, status }) => ({
      url: `candidate-referrals/candidate/${candidateId}`,
      params: { status },
      method: 'GET',
    }),
    providesTags: ['CandidateReferrals'],
  });
